const getArrayAsString = (items, conjunctionLabel) => {
    if ((items === null || items === void 0 ? void 0 : items.length) <= 1) {
        return items;
    }
    const commaItems = items.slice(0, -1).join(', ');
    const lastItem = items[items.length - 1];
    return `${commaItems} ${conjunctionLabel} ${lastItem}`;
};
export default getArrayAsString;
